import { Endpoint } from '../endpoint';
import { GCNotification } from '@business/entities/notifications';
import { R } from '@core/utils/r';

export function getNotiifcations(after?: number) {
  return Endpoint.get<GCNotification[]>(`@gc/notifications`, { params: R.objectCompact({ after }) });
}

export function getNotificationCount() {
  return Endpoint.get<{ count: number }>(`@gc/notifications/count`);
}

export function markRead(id: string) {
  return Endpoint.post<void>(`@gc/notifications/read`, { data: { id } });
}

export function markAllRead() {
  return Endpoint.post<void>(`@gc/notifications/read-all`);
}
